import getNumberTranslation from "../assets/numbers/numberTable";

const hasTimeRegex = /\b(\d{1,2})(?=:|h)([:h]\d{2})?\b|\b(\d{1,2})h\b/; ///\b(\d{1,2})(?=:|h)([:h]\d{2})?\b/;

export default function convertTime(str, cardText, lang = "en") {
  const strHasTime = hasTimeRegex.test(str);
  if (!strHasTime) return str;
  // extracted time
  const time = hasTimeRegex.exec(str)[0];
  // translate time
  const newTime = translateTime(time, lang);

  if (!newTime) return str;
  let minutes = "";

  // if there are minute options, pick the cloested match (ex: trienta vs media)
  if (newTime?.minutes?.length > 1) {
    minutes = getMinuteValue(newTime.minutes, cardText);
  } else if (newTime?.minutes?.length === 1) {
    minutes = newTime.minutes[0];
  }
  const timeString = `${newTime.hour} ${newTime.connector} ${minutes || ""}`;
  return str.replace(time, timeString);
}

const getMinuteValue = (minutes, str) => {
  for (const minute of minutes) {
    if (str.includes(minute)) {
      return minute;
    }
  }
  return minutes[0];
};

const minuteOptions = new Set([15, 30, 45]);

function translateTime(time, lang = "en") {
  const match = time.match(/\b(\d{1,2})[:h]?(\d{2})?\b/); //
  if (!match) {
    return null;
  }

  // Extract the hour and minute components from the match
  const hour = parseInt(match[1], 10);
  const minute = match[2] ? parseInt(match[2], 10) : 0;

  // Translate the hour and minute components to the target language
  const translatedHour = getNumberTranslation(hour, lang);
  const translatedMinute =
    minute === 0 ? "" : getNumberTranslation(minute, lang);
  const connector = timeConnectors[lang];

  //get minute alternatives for 15, 30, 45 minutes
  if (minuteOptions.has(minute)) {
    const minuteAlternatives = getMinuteAlternatives(minute, lang);
    return {
      hour: translatedHour,
      minutes: [translatedMinute, ...minuteAlternatives],
      connector,
    };
  }
  return {
    hour: translatedHour,
    minutes: [translatedMinute],
    connector,
  };
}

function getMinuteAlternatives(minute, lang) {
  switch (minute) {
    case 15:
      return minuteAlternatives[15][lang];
    case 30:
      return minuteAlternatives[30][lang];
    case 45:
      return minuteAlternatives[45][lang];
    default:
      return minute;
  }
}

const minuteAlternatives = {
  15: {
    en: ["quarter"],
    fr: ["quart"],
    es: ["cuarto", "y un cuarto", "y cuarto"],
  },
  30: {
    en: ["half"],
    fr: ["demi", "demi-heure", "et demie"],
    es: ["media", "y media"],
  },
  45: {
    en: ["three quarters"],
    fr: ["trois quarts"],
    es: ["tres cuartos"],
  },
};
const timeConnectors = {
  en: "",
  fr: "heures",
  es: "y",
};
